
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <>
      <style>{`
  .footer-section {
    background: #f8f9fa;  /* 浅灰色背景 */
    color: #6b7280;
    padding: 64px 0 32px;
   
    border-top: 1px solid #e5e7eb;
  }
  
  .footer-brand {
    margin-bottom: 24px;
  }
  
  .footer-logo {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;  /* 深色文字 */
    margin-bottom: 12px;
    cursor: pointer;
  }
  
  .footer-tagline {
    font-size: 14px;
    line-height: 1.6;
    color: #6b7280;
    max-width: 280px;
  }
  
  .footer-newsletter {
    margin-top: 32px;
  }
  
  .newsletter-title {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 12px;
  }
  
  .newsletter-form {
    display: flex;
    gap: 8px;
    max-width: 320px;
  }
  
  .newsletter-input {
    flex: 1;
    padding: 10px 14px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    color: #1a1a1a;
    font-size: 14px;
    outline: none;
    transition: all 0.3s;
  }
  
  .newsletter-input::placeholder {
    color: #9ca3af;
  }
  
  .newsletter-input:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }
  
  .newsletter-btn {
    padding: 10px 20px;
    background: #1a1a1a;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
  }
  
  .newsletter-btn:hover {
    background: #000000;
    transform: translateY(-1px);
  }
  
  .footer-column h4 {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 20px;
    letter-spacing: 0.5px;
  }
  
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .footer-links li {
    margin-bottom: 12px;
  }
  
  .footer-links a {
    color: #6b7280;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s;
    cursor: pointer;
  }
  
  .footer-links a:hover {
    color: #1a1a1a;
  }
  
  .footer-bottom {
    border-top: 1px solid #e5e7eb;
    margin-top: 48px;
    padding-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
  }
  
  .footer-copyright {
    font-size: 13px;
    color: #9ca3af;
  }
  
  .footer-bottom-links {
    display: flex;
    gap: 24px;
    align-items: center;
  }
  
  .footer-bottom-links a {
    color: #6b7280;
    text-decoration: none;
    font-size: 13px;
    transition: color 0.3s;
  }
  
  .footer-bottom-links a:hover {
    color: #1a1a1a;
  }
  
  .footer-social {
    display: flex;
    gap: 12px;
  }
  
  .social-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    transition: all 0.3s;
    cursor: pointer;
  }
  
  .social-icon:hover {
    background: #1a1a1a;
    border-color: #1a1a1a;
    color: #ffffff;
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    .footer-bottom {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .footer-bottom-links {
      flex-wrap: wrap;
    }
  }
`}</style>
      <footer className="footer-section">
        <Container>
          <Row>
            {/* Brand Column */}
            <Col lg={4} md={6} className="mb-4">
              <div className="footer-brand">
                <div className="footer-logo" onClick={() => navigate("/")}>
                  CityGetAway
                </div>
                <p className="footer-tagline">
                  Discover personalized city adventures powered by AI. Plan
                  smarter, travel better.
                </p>
              </div>

              <div className="footer-newsletter">
                <div className="newsletter-title">
                  Subscribe to our newsletter
                </div>
                <form
                  className="newsletter-form"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <input
                    type="email"
                    className="newsletter-input"
                    placeholder="Enter your email"
                  />
                  <button type="submit" className="newsletter-btn">
                    Subscribe
                  </button>
                </form>
              </div>
            </Col>

            {/* Product Column */}
            <Col lg={2} md={6} className="mb-4">
              <div className="footer-column">
                <h4>Product</h4>
                <ul className="footer-links">
                  <li>
                    <a onClick={() => navigate("/features")}>Features</a>
                  </li>
                  <li>
                    <a onClick={() => navigate("/pricing")}>Pricing</a>
                  </li>
                  <li>
                    <a onClick={() => navigate("/mobile")}>Mobile App</a>
                  </li>
                  <li>
                    <a onClick={() => navigate("/integrations")}>
                      Integrations
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Company Column */}
            <Col lg={2} md={6} className="mb-4">
              <div className="footer-column">
                <h4>Company</h4>
                <ul className="footer-links">
                  <li>
                    <a onClick={() => navigate("/about")}>About Us</a>
                  </li>
                  <li>
                    <a onClick={() => navigate("/blog")}>Blog</a>
                  </li>
                  <li>
                    <a onClick={() => navigate("/careers")}>Careers</a>
                  </li>
                  <li>
                    <a onClick={() => navigate("/contact")}>Contact</a>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Resources Column */}
            <Col lg={2} md={6} className="mb-4">
              <div className="footer-column">
                <h4>Resources</h4>
                <ul className="footer-links">
                  <li>
                    <a onClick={() => navigate("/help")}>Help Center</a>
                  </li>
                  <li>
                    <a onClick={() => navigate("/community")}>Community</a>
                  </li>
                  <li>
                    <a onClick={() => navigate("/guides")}>Guides</a>
                  </li>
                  <li>
                    <a
                      href="https://docs.citygetaway.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      API Docs
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Social Icons */}
            <Col lg={2} md={12} className="mb-4">
              <div className="footer-column">
                <h4>Connect</h4>
                <div className="footer-social">
                  <a
                    className="social-icon"
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a
                    className="social-icon"
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    className="social-icon"
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a
                    className="social-icon"
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-linkedin"></i>
                  </a>
                </div>
              </div>
            </Col>
          </Row>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="footer-copyright">
              © {currentYear} CityGetAway. All rights reserved.
            </div>
            <div className="footer-bottom-links">
              <a onClick={() => navigate("/privacy")}>Privacy Policy</a>
              <a onClick={() => navigate("/terms")}>Terms of Service</a>
              <a onClick={() => navigate("/cookies")}>Cookie Policy</a>
              <a onClick={() => navigate("/contact")}>Contact</a>
            </div>
          </div>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
